import { stopStream } from 'components/UserMedia/helpers/track/stopStream';

export class FakeVideoTrack {
  private _canvasDomElement: HTMLCanvasElement | null;
  private _canvasStream: MediaStream | null;
  private _drawIntervalId: number | null;

  get fakeTrack(): MediaStreamTrack | undefined {
    if (!this._canvasStream) {
      this._initFakeStream();
    }
    this._statPlaying();
    return this._canvasStream?.getVideoTracks()[0];
  }

  public stopFakeStream(): void {
    if (!this._canvasStream) {
      return;
    }

    if (this._drawIntervalId !== null) {
      clearInterval(this._drawIntervalId);
      this._drawIntervalId = null;
    }

    stopStream(this._canvasStream);
    this._canvasStream = null;

    if (this._canvasDomElement?.parentElement) {
      this._canvasDomElement.remove();
      this._canvasDomElement = null;
    }
  }

  private _statPlaying(): void {
    if (!this._canvasDomElement) {
      return;
    }

    const canvas = this._canvasDomElement.getContext('2d');
    if (!canvas) {
      return;
    }

    this._drawIntervalId = setInterval(() => {
      canvas.fillStyle = `rgb(${Math.random() * 255},0,0)`;
      canvas?.fillRect(0, 0, 1, 1);
      const track = this._canvasStream?.getVideoTracks()[0] as CanvasCaptureMediaStreamTrack;
      track.requestFrame();
    }, 1000 / 30);
  }

  private _initFakeStream(): void {
    if (this._canvasStream) {
      this.stopFakeStream();
    }

    this._canvasDomElement = document.createElement('canvas');
    this._canvasDomElement.width = 240;
    this._canvasDomElement.height = 240;
    this._canvasStream = this._canvasDomElement.captureStream(29);
  }
}
